import ini from "refractor/ini";
export default ini;